import React from 'react';
import { widget, version } from './charting_library.min.js';
import DataFeeds from './datafeed';
import webstomp from "webstomp-client";

const toDouble = (time) => {
  if (String(time).length < 2) return "0" + time;
  return time;
};
// 将GTM时区转化为 olsondb 格式
const olsondb = (timezone) => {
  let olsondbList = {
    "-10": "Pacific/Honolulu",
    "-9": "America/Juneau",
    "-8": "America/Los_Angeles",
    "-7": "America/Phoenix",
    "-6": "America/Chicago",
    "-5": "America/Bogota",
    "-4": "America/Caracas",
    "-3": "America/Argentina/Buenos_Aires",
    "0": "Etc/UTC",
    "1": "Europe/Zurich",
    "2": "Europe/Vilnius",
    "3": "Europe/Moscow",
    "4": "Asia/Muscat",
    "5": "Asia/Ashkhabad",
    "5.5": "Asia/Kolkata",
    "5.75": "Asia/Kathmandu",
    "6": "Asia/Almaty",
    "7": "Asia/Jakarta",
    "8": "Asia/Hong_Kong",
    "9": "Asia/Seoul",
    "9.5": "Australia/Adelaide",
    "10": "Australia/Melbourne",
    "11": "Pacific/Pohnpei",
    "12": "Pacific/Auckland",
    "12.75": "Pacific/Chatham",
    "13": "Pacific/Fakaofo",
  };
  return olsondbList[timezone] || "Australia/Melbourne";
}

class App extends React.Component {
  componentDidMount() {
    console.log(version()); //打印版本号
    // 从url中获取 产品code 语言 时区 报价小数位
    let param,symbol,lang,localTimezone,pricescale;
    param = new URLSearchParams(window.location.search);
    symbol = param.get('symbol');
    lang = param.get('lang');
    pricescale = param.get("pricescale");
    localTimezone = (new Date().getTimezoneOffset() / 60) * -1;
    symbol ? (symbol = param.get("symbol")) : (symbol = "EURUSD");
    lang ? (lang = param.get("lang")) : (lang = "en");
    pricescale ? (pricescale = param.get("pricescale")) : (pricescale = "5");

    const store = {
      ws: new WebSocket("wss://app." + DataFeeds.prototype.getBaseUrl() + "/ws/websocket"),
      onDataCallback: null,
      onRealTimeCallback: null,
      to: null,
      xhrOver: false, //k线历史数据是否加载完成
      lang: lang, //语言
      symbol: symbol, //产品code
      localTimezone: localTimezone, //时区
      pricescale: pricescale,//价格精度
    };
    const headers = {};
    const apiUrl = "/public/topics/instruments/quotations/single/"+ store.symbol;

    const StompClient = webstomp.over(
      new WebSocket("wss://app." + DataFeeds.prototype.getBaseUrl() + "/ws/websocket")
    );
    StompClient.connect(headers, function (frame) {
      //订阅
      StompClient.subscribe(apiUrl, function (greeting) {
        // websocket获取数据处理
        let wsData = JSON.parse(greeting.body);
        if (store.xhrOver) {
          let tickCreate = {
            time: wsData.updateTimestamp * 1,
            close: wsData.sellPrice,
            open: wsData.sellPrice,
            high: wsData.sellPrice,
            low: wsData.sellPrice
          };
          let tickUpdate = {
            time: wsData.updateTimestamp * 1,
            close: wsData.sellPrice,
            open: store.lastData.open,
            high: store.lastData.high,
            low: store.lastData.low
          };
          let tick = null;
          if (store.period === "D1") {            
            // moment(store.lastData.time).format("YYYY-MM-DD") ===
            // moment(wsData.updateTimestamp).format("YYYY-MM-DD")
            //   ? (tick = tickUpdate)
            //   : (tick = tickCreate);
            tick = tickUpdate;
          } else if (store.period === "W1") {
            // wsData.updateTimestamp - store.lastData.time > 604799000
            //   ? (tick = tickCreate)
            //   : (tick = tickUpdate);
            tick = tickUpdate;
          } else if (store.period === "MO1") {
            // moment(store.lastData.time).format("YYYY-MM") ===
            // moment(wsData.updateTimestamp).format("YYYY-MM")
            //   ? (tick = tickUpdate)
            //   : (tick = tickCreate);
            tick = tickUpdate;
          } else {
            tick = tickCreate;
          }
          store.onRealTimeCallback(tick);
         
          //官网头部行情适配start
          const parent = window.parent;
          if (window.parent.document.getElementsByClassName("dailyPercent").length>0) {
            parent.document.getElementsByClassName("nowPrice")[0].innerHTML =
              (wsData.sellPrice*1).toFixed(store.pricescale);
            parent.document.getElementsByClassName("sell-price-num")[0].innerHTML = (
              wsData.sellPrice * 1
            ).toFixed(store.pricescale);  
            parent.document.getElementsByClassName("buy-price-num")[0].innerHTML = (
              wsData.buyPrice * 1
            ).toFixed(store.pricescale);
            parent.document.getElementsByClassName(
              "dailyPercent"
            )[0].innerHTML = (wsData.dailyChangeInPercentage * 100).toFixed(2)+'%';   
            store.lastData.close*1 - wsData.sellPrice*1 > 0
             ? parent.document.getElementsByClassName("directIcon")[0].className = "directIcon glyphicon glyphicon-triangle-bottom down"
             : parent.document.getElementsByClassName("directIcon")[0].className = "directIcon glyphicon glyphicon-triangle-top up";
            store.lastData.close = wsData.sellPrice;
          }
          // 官网头部适配end
        }
      });
    });

    const tv = new widget({
      debug: false,
      symbol: store.symbol,
      timezone: olsondb(store.localTimezone),
      fullscreen: true,
      interval: "15",
      container_id: "chart-container-id",
      library_path: "/charting_library/",
      locale: store.lang,
      autosize: true,
      datafeed: new DataFeeds(store),
      theme: "Light",
      favorites: {
        intervals: ["1", "15", "30", "60", "1D", "1W", "1M"],
        chartTypes: ["Bars", "Candles", "Area"]
      },
      customFormatters: {
        timeFormatter: {
          format: date => {
            var _format_str = "%h:%m";
            return _format_str
              .replace("%h", toDouble(date.getUTCHours()), 2)
              .replace("%m", toDouble(date.getUTCMinutes()), 2)
              .replace("%s", date.getUTCSeconds(), 2);
          }
        },
        dateFormatter: {
          format: date => {
            return (
              date.getUTCFullYear() +
              "-" +
              toDouble(date.getUTCMonth() + 1) +
              "-" +
              toDouble(date.getUTCDate())
            );
          }
        }
      },
      studies_access: {
        //禁用指标
        type: "black",
        tools: [
          { name: "Correlation - Log" },
          { name: "Correlation Coefficient" },
          { name: "Spread" },
          { name: "Volume Oscillator" },
          { name: "Volume" },
          { name: "Ratio" },
          { name: "Price Volume Trend" },
          { name: "On Balance Volume" },
          { name: "Net Volume" },
          { name: "Accumulation/Distribution" },
          { name: "Ease Of Movement" },
          { name: "Elder's Force Index" },
          { name: "Chaikin Money Flow" },
          { name: "Chaikin Oscillator" },
          { name: "VWAP" },
          { name: "VWMA" }
        ]
      },
      time_frames: [],
      disabled_features: [
        //禁用功能
        "header_symbol_search",
        "symbol_search_hot_key",
        "header_compare",
        "header_undo_redo",
        "header_screenshot",
        "volume_force_overlay",
        "left_toolbar", //左侧工具栏(官网隐藏)
        "widget_logo", //logo
        "header_fullscreen_button",
        "symbol_info", //暂时屏蔽 产品信息功能
        "header_settings", //右上角设置按钮
        "pane_context_menu" //右击图表设置窗口暂时关闭
      ],
      enabled_features: [
        //启用的功能
        "dont_show_boolean_study_arguments", //是否隐藏指标参数
        "hide_last_na_study_output", //隐藏最后一次指标输出
        "same_data_requery",
        "side_toolbar_in_fullscreen_mode",
        "adaptive_logo",
        "header_screenshot" //截图功能
      ],
      overrides: {
        // "paneProperties.vertGridProperties.color": "#ffffff", //横向背景格
        // 左上角ma指标设置
        "paneProperties.legendProperties.showStudyArguments": true,
        "paneProperties.legendProperties.showStudyTitles": true,
        "paneProperties.legendProperties.showStudyValues": true,
        "paneProperties.legendProperties.showSeriesTitle": true,
        "paneProperties.legendProperties.showSeriesOHLC": true,
        "paneProperties.legendProperties.showLegend": false,
        "paneProperties.legendProperties.showBarChange": false,
        "paneProperties.legendProperties.showOnlyPriceSource": true
      },
      snapshot_url: "https://www." + DataFeeds.prototype.getBaseUrl() + "/api/v2/tvSnapShot"
    });

    tv.onChartReady(() => {
      const chart = tv.chart();
      // // 创建macd指标
      // chart.createStudy("MACD", false, false, [14, 30, "close", 9]);

      // 创建ma线  出现均线在0刻度，注意数据类型为number
      const colors = ["#e0d283", "#92c580", "#8dc1d9"];
      [5, 10, 30].forEach((time, index) => {
        //1.15写法 1.14不同
        chart.createStudy("Moving Average", false, false, [time, "close", 0], {
          "Plot.linewidth": 2,
          "plot.color.0": colors[index],
          precision: 2
        });
      });
    });
  }

  render() {
    return (
      <div className="container">
        <div id="chart-container-id" />
      </div>
    );
  }
}

export default App;
